import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { KaimonoWebRoutes } from 'src/config/routes';
import { CLOUD_FRONT_IMAGE_PATH } from 'src/constants/imagePath';
import { useWindowDimensions } from 'src/hooks/useWindowDimensions';
import { I18nContext } from 'src/stores/I18n';
import type { LOCALE_TYPE } from 'src/types/locale';
import { isLocaleHk } from 'src/utils/locale';
import { mixpanel } from 'src/utils/mixpanel';

type MiniBannerObj = {
  slug: 'popular-cosmetic-sets' | 'whatsapp';
  href: string;
  target: string;
  src: string;
  alt: string;
};

type Props = {
  section: 'sideMenuBar' | 'hamburgerMenu';
};

export const MiniBanner: React.FC<Props> = ({ section }) => {
  const { locale } = useRouter();
  const localeResources = useContext(I18nContext);
  const { width } = useWindowDimensions();
  const isPC = width >= 576;

  const bannerConfig: MiniBannerObj = isLocaleHk(locale as LOCALE_TYPE)
    ? {
        slug: 'whatsapp',
        href: 'https://whatsapp.com/channel/0029Vb7uhcb3rZZk5e4lGX0v',
        target: '_blank',
        src: `${CLOUD_FRONT_IMAGE_PATH}/shared/mini-banner/whatsapp/${locale}.webp`,
        alt: ''
      }
    : {
        slug: 'popular-cosmetic-sets',
        href: `/kaimono${KaimonoWebRoutes.featured.show('popular-cosmetic-sets')}`,
        target: '_self',
        src: `${CLOUD_FRONT_IMAGE_PATH}/shared/mini-banner/popular-cosmetic-sets/${locale}.webp`,
        alt: localeResources.featured.popularCosmeticSets
      };

  return (
    <>
      {section === 'sideMenuBar' ? (
        <a
          href={bannerConfig.href}
          target={bannerConfig.target}
          rel="noopener noreferrer"
          className="hover:opacity-75"
          data-testid="mini-banner-link"
          onClick={() => {
            mixpanel.onPcSideMenuBarBannerClicked(`/featured/${bannerConfig.slug}`, bannerConfig.slug);
          }}
        >
          <NextImage src={bannerConfig.src} alt={bannerConfig.alt} width={270} height={180} layout="responsive" />
        </a>
      ) : (
        <div className={classNames('w-full mx-auto max-w-[270px]', 'semiSm:max-w-[175px]')}>
          <a
            href={bannerConfig.href}
            target={bannerConfig.target}
            rel="noopener noreferrer"
            className="hover:opacity-75"
            onClick={() => {
              mixpanel.onHamburgerMenuClicked('mini-banner');
            }}
          >
            <NextImage
              src={bannerConfig.src}
              alt={bannerConfig.alt}
              width={isPC ? 175 : 270}
              height={isPC ? 115 : 180}
              layout="responsive"
            />
          </a>
        </div>
      )}
    </>
  );
};
